/** @jsxImportSource react */
import SearchBoxContainer from '@react/search/components/SeachBoxContainer';
import Heading from '@react/system/Heading';
import { GoogleSearchSuggestion } from '@sly/core/api/types/search';

export interface FindLocalAgentProps {
  onLocationSearch: (result: GoogleSearchSuggestion) => void;
  placeholder?: string;
}

export default function FindLocalAgent({
  onLocationSearch,
  placeholder,
}: FindLocalAgentProps) {
  return (
    <div
      className='w-full rounded bg-white p-12'
      data-tp-id='gen-div-4367bb66-7abf-4d47-8595-9962407b7dc6'
    >
      <div
        className='m-auto text-center'
        data-tp-id='gen-div-af265b8d-d85d-4e55-889f-6b1baf324e2f'
      >
        <Heading
          className='font-b-l mb-2 text-4xl font-normal'
          as='h1'
          font='font-b-l'
          data-tp-id='gen-Heading-bb7ab54b-443e-4ccb-9b29-c6f61f246b73'
        >
          Find your local senior living agent
        </Heading>
        <div
          className='mb-xl'
          data-tp-id='gen-div-a0251791-c025-4504-812c-0c4641797725'
        >
          Our local advisors can help you find the perfect living arrangement.
          Work with one of our senior living agents to find the perfect home for
          mom or dad
        </div>
      </div>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*@ts-ignore*/}
      <SearchBoxContainer
        className='m-auto max-w-[var(--col6)]'
        onLocationSearch={onLocationSearch}
        placeholder={placeholder}
      />
    </div>
  );
}
